<template>
  <div class="page-wrapper">
    <div class="searchBox">
      <div class="left">
        <el-form :inline="true" size="small">
          <el-form-item>
            <el-input
              placeholder="请输入课程标题"
              v-model="searchForm.name"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.source"
              clearable
              placeholder="请选择课程来源"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="自营课程" :value="1"></el-option>
              <el-option label="合作机构课程" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.state"
              clearable
              placeholder="请选择课程状态"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="在售" :value="1"></el-option>
              <el-option label="已下架" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-search"
              type="primary"
              @click="searchHandle"
              >查询</el-button
            >
            <el-button
              type="primary"
              @click="resetHandle"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="right">
          <el-button size="small" type="primary" @click="toAddCourse">新增课程</el-button>
      </div>
    </div>
    <div class="tableBox">
      <el-table v-loading="isLoading" :data="tableData" size="small">
        <el-table-column label="序号" width="50" type="index">
        </el-table-column>
        <el-table-column label="课程标题">
          <template slot-scope="scope">
            {{scope.row.name}}
          </template>
        </el-table-column>
        <el-table-column label="课程简介">
          <template slot-scope="scope">
            {{scope.row.brief}}
          </template>
        </el-table-column>
        <el-table-column label="上课时间">
          <template slot-scope="scope">
            {{scope.row.startT}}
            <br>至<br>
            {{scope.row.endT}}
          </template>
        </el-table-column>
        <el-table-column label="上课地点">
          <template slot-scope="scope">
            {{scope.row.region}}
          </template>
        </el-table-column>
        <el-table-column label="课程价格">
          <template slot-scope="scope">
            ￥{{scope.row.price}}
          </template>
        </el-table-column>
        <el-table-column label="课程来源">
          <template slot-scope="scope">
            {{scope.row.sourceName}}
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-tag size="mini" type="success" v-if="scope.row.state === 1">在售</el-tag>
            <el-tag size="mini" type="danger" v-if="scope.row.state === 2">已下架</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <el-button
              type="primary"
              plain
              size="mini"
              @click="toDetail(scope.row)"
              >详情</el-button
            >
            <el-button
              v-if="scope.row.state == 1"
              type="primary"
              plain
              size="mini"
              @click="updateStateHandle(scope, 2)"
              >下架</el-button
            >
            <el-button
              v-if="scope.row.state == 2"
              type="primary"
              plain
              size="mini"
              @click="updateStateHandle(scope, 1)"
              >发布</el-button
            >
            <el-button
              type="danger"
              plain
              size="mini"
              @click="delCourseHandle(scope)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageBox">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pagination.current"
        :page-size.sync="pagination.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { utils } from "@/common/common.js";
import { api, request } from "@/common/request_course.js";
// import { buildThumborUrl } from '@/common/tool.js'
import { Loading } from 'element-ui';
import qs from 'qs'
export default {
  name: "anchorList",
  data() {
    return {
      isLoading: false,
      searchForm: {
        name: '',
        source: '',
        state: '',
      },
      pagination: {
        current: 1,
        size: 10,
        total: 0,
      },
      //表格
      tableData: [1, 2, 3],
      detailVisible: false,
      detailData: {},
      
      handleRowIndex: null
    };
  },
  computed: {
    adminId() {
      return utils.getAdminId();
    },
    token() {
      return utils.getToken();
    },
  },
  watch: {
    $route: {
      handler: function (route) {
        let query = route.query
        this.pagination.size = Number(query.size)
          ? Number(query.size)
          : 10;
        this.pagination.current = Number(query.current)
          ? Number(query.current)
          : 1;
        this.searchForm.name = query.name 
          ? query.name
          : ''
        this.searchForm.source = query.source 
          ? Number(query.source)
          : ''
        this.searchForm.state = query.state 
          ? Number(query.state)
          : ''
        this.getCourseList();
      },
      immediate: true,
    },
  },
  methods: {
    toDetail(row) {
      this.$router.push('/course/detail?id=' + row.id)
    },
    // 上下架
    updateStateHandle(scope, state) {
      console.log(scope)
      let tip = ''
      if (state == 1) tip = '确定发布该课程吗？'
      if (state == 2) tip = '确定下架该课程吗？'
      this.$confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.requestUpdateState(scope, state)
      }).catch(() => {
        console.log('已取消')
      })
    },
    requestUpdateState(scope, state) {
      let loadingInstance = Loading.service({
        text: '正在提交...'
      });
      request({
        url: api.baseUrl + "/course/updateByState",
        method: "post",
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        data: qs.stringify({
          courseId: scope.row.id,
          state,
          updateBy: this.adminId
        })
      })
      .then((res) => {
        console.log(res);
        if (res.erroyCode == 200) {
          let index = scope.$index
          this.tableData[index].state = state
          let tip = state == 1 ? '发布' : 
            state == 2 ? '下架' : '操作'
          this.$message.success(`${tip}成功`)
        } else {
          this.$message.error(res.errorMsg || "网络错误");
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        loadingInstance.close()
      });
    },

    // 删除
    delCourseHandle(scope) {
      this.$confirm('确定删除该课程吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'danger'
      }).then(() => {
        this.requestdelCourse(scope)
      }).catch(() => {
        console.log('已取消')
      })
    },
    requestdelCourse(scope) {
      let loadingInstance = Loading.service({
        text: '正在提交...'
      });
      request({
        url: api.baseUrl + "/course/remove?courseIds=" + scope.row.id,
        method: "post",
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        data: qs.stringify({
          updateBy: this.adminId
        })
      })
      .then((res) => {
        console.log(res);
        loadingInstance.close()
        if (res.erroyCode == 200) {
          this.$message.success(`删除成功`)
          this.updateRouter()
        } else {
          this.$message.error(res.errorMsg || "网络错误");
        }
      })
      .catch((err) => {
        loadingInstance.close()
        console.log(err);
      })
    },

    toAddCourse() {
      this.$router.push('/course/add')
    },
    getCourseList() {
      this.isLoading = true;
      let params =  {
        current: this.pagination.current,
        size: this.pagination.size,
      }
      let name = this.searchForm.name.trim()
      if (name !== '') params.name = name

      let source = this.searchForm.source
      if (source !== '') params.source = +source

      let state = this.searchForm.state
      if (state !== '') params.state = +state
      request({
        url: api.baseUrl + "/course/pageList",
        method: "get",
        params
      })
      .then((res) => {
        console.log(res);
        if (res.erroyCode == 200) {
          this.pagination.total = parseInt(res.data.total);
          this.tableData = res.data.records.map(item => {
            let sourceName = item.source == 1 ? '自营' : item.source == 2 ? '合作机构' : '-'; 
            return {
              ...item,
              startT: item.startTime.slice(0, 16),
              endT: item.endTime.slice(0, 16),
              region: item.provinceName + ' ' + item.cityName + ' ' + item.districtName,
              sourceName,
            }
          });
        } else {
          this.$message.error(res.errorMsg || "网络错误");
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.isLoading = false;
      });
    },
    searchHandle() {
      console.log(this.searchForm);
      console.log("searchHandle");
      this.pagination.page = 1;
      this.updateRouter();
    },
    resetHandle() {
      this.searchForm.name = ''
      this.searchForm.source = ''
      this.searchForm.state = ''
      this.pagination.page = 1;
      this.updateRouter();
    },
    updateRouter() {
      let str = "?current=" +
        this.pagination.current +
        "&size=" +
        this.pagination.size

      if (this.searchForm.name) {
        str += "&name=" + this.searchForm.name.trim()
      }

      if (this.searchForm.source !== '') {
        str += "&source=" + this.searchForm.source
      }

      if (this.searchForm.state !== '') {
        str += "&state=" + this.searchForm.state
      }

      str += '&r=' + new Date().getTime()

      this.$router.push(
        "/course/list" + str
      );
    },
    handleSizeChange(size) {
      //分页：每页n条
      this.pagination.size = size;
      this.pagination.current = 1;
      this.updateRouter();
    },
    handleCurrentChange(current) {
      //分页：改变第n页
      this.pagination.current = current;
      this.updateRouter();
    },
  },
};
</script>

<style scoped lang="scss">
.page-wrapper {
  background: #fff;
  padding: 16px;
  margin: 10px;
}
.searchBox {
  .left {
    float: left;
  }
  .right {
    float: right;
    line-height: 32px;
  }
}
.searchBox:after {
  content: "";
  display: block;
  clear: both;
}
.tableBox {
  padding: 16px 0;
}
.detail-wrap {
  padding: 16px 16px 64px;
  .line { padding: 16px 0; display: flex;}
  .label {width: 72px; text-align: right; padding-right: 8px; color: #666; flex-shrink: 0; font-size: 13px;}
  .value {color: #000; font-size: 13px;}
  .img {width: 64px; height: 64px; object-fit: cover; margin-right: 8px;}
}

</style>



// WEBPACK FOOTER //
// src/pages/course/list.vue